<template>
  <el-col :span="24">
    <div
      class="ma-0"
      v-loading="loading"
      :element-loading-spinner="svg"
      element-loading-svg-view-box="-10, -10, 50, 50"
      element-loading-background="rgba(122, 122, 122, 0.8)"
    >
      <div class="custom-table-design">
      <el-table
        :data="userDataList"
        :fit="true"
        height="300"
        stripe
        :row-class-name="tableRowClassName"
        @row-click="handleRowClick"
        class="my-2 data-table"
        scrollbar-always-on: false
      >
        <el-table-column
          :label="'Subject'"
          :prop="'subject'"
          :width="$vuetify.display.width <= 1600 ? 250 : ''"
          sortable
        >
          <template #default="scope">
            <span class="line-clamp-2"> {{ scope.row.subject }} </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="'Date'"
          :prop="'support_date'"
          :width="$vuetify.display.width <= 1600 ? 150 : ''"
          sortable
        >
          <template #default="scope">
            <i class="fa fa-calendar f-14 text-white mr-2"></i>
            {{ scope.row.support_date == null ? "" : scope.row.support_date.split("T")[0].substring(0, 19) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Time'"
          :prop="'support_time'"
          :width="$vuetify.display.width <= 1600 ? 150 : ''"
          sortable
        >
          <template #default="scope">
            <i class="fa fa-clock-o f-14 text-white mr-2"></i>
            {{ scope.row.support_time == null ? "" : scope.row.support_time.split("T")[1].substring(0, 19) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Status'"
          :prop="'status_id'"
          :width="$vuetify.display.width <= 1600 ? 160 : ''"
          sortable
        >
          <template #default="scope">
            <h6 class="mb-0">
              <span
                class="badge width-120"
                :class="
                  scope.row.status_id === '1'
                    ? 'badge-primary'
                    : scope.row.status_id === '2'
                    ? 'badge-warning'
                    : scope.row.status_id === '3'
                    ? 'badge-secondary'
                    : scope.row.status_id === '4'
                    ? 'badge-info'
                    : scope.row.status_id === '5'
                    ? 'badge-success'
                    : 'badge-dark'
                "
              >
                {{
                  scope.row.status_id === "1"
                    ? "Sent"
                    : scope.row.status_id === "2"
                    ? "Processing"
                    : scope.row.status_id === "3"
                    ? "Admin responded"
                    : scope.row.status_id === "4"
                    ? "User responded"
                    : scope.row.status_id === "5"
                    ? "Finalized"
                    : "Closed"
                }}
              </span>
            </h6>
          </template>
        </el-table-column>
        <el-table-column
          :label="'Last follow up'"
          :prop="'last_follow_up'"
          :width="$vuetify.display.width <= 1600 ? 180 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.support_details.length == 0
                ? formattedDate(scope.row.created_at)
                : formattedDate(maxDate(scope.row.support_details))
            }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'# messages'"
          :prop="'conversations_count'"
          :width="$vuetify.display.width <= 1600 ? 170 : ''"
          sortable
        >
          <template #default="scope">
            <el-tag class="ml-2" type="info" effect="dark">
              <i class="fa fa-comments mr-1"></i>
              {{ scope.row.support_details.length + 1 }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          v-if="$vuetify.display.width < 500"
          :label="'Actions'"
          :prop="'operations'"
          :width="$vuetify.display.width <= 1600 ? 150 : ''"
          align="center"
        >
          <template #default="scope">

            <el-tooltip placement="top" effect="light">
                <template #content>More Info</template>
                <el-button
                  v-if="
                    scope.row.id != null && scope.row.id != ''
                  "
                  @click.stop="handleShow(scope.$index, scope.row)"
                  size="small"
                  class="height-25 rounded-2 m-0 ml-2"
                  color="#DDF0AC"
                  style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                >
                    <svg style="width: 24px; height: 24px;">
                        <use href="@/assets/svg/newSvgIcon.svg#tableOperationMoreInfo"></use>
                    </svg>
                </el-button>
              </el-tooltip>

          </template>
        </el-table-column>
        <el-table-column
          v-else
          fixed="right"
          :label="'Status'"
          :prop="'operations'"
          :width="$vuetify.display.width <= 1600 ? 150 : ''"
          align="center"
        >
          <template #default="scope">
            <el-tooltip placement="top" effect="light">
                <template #content>More Info</template>
                <el-button
                  v-if="
                    scope.row.id != null && scope.row.id != ''
                  "
                  @click.stop="handleShow(scope.$index, scope.row)"
                  size="small"
                  class="height-25 rounded-2 m-0 ml-2"
                  color="#DDF0AC"
                  style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                >
                    <svg style="width: 24px; height: 24px;">
                        <use href="@/assets/svg/newSvgIcon.svg#tableOperationMoreInfo"></use>
                    </svg>
                </el-button>
              </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <el-row class="row-bg" justify="space-between">
        <el-col
          :span="5"
          class="d-flex justify-content-start align-items-center"
        >
          <el-select
            v-model="perPageCount"
            placeholder="Select"
            size="small"
            style="width: 70px"
          >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
          </el-select>
        </el-col>
        <el-col
          :span="8"
          class="d-flex align-items-center justify-content-center"
        >
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :total="total_items"
            v-model:page-size="page_size"
            v-model:current-page="current_page"
            @current-change="changePage"
            class="my-4"
          />
        </el-col>
        <el-col :span="5" class="d-flex justify-content-end align-items-center">
          <span class="text-white">
            {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
              current_page * perPageCount > total_items
                ? total_items.toLocaleString()
                : (current_page * perPageCount).toLocaleString()
            }}
            of {{ total_items.toLocaleString() }}
          </span>
        </el-col>
      </el-row>
    </div>
  </el-col>
</template>

<script>
// import { ElMessageBox } from "element-plus";
// import ShowDetail from "./dialogDetail.vue";
// import UserService from "../../services/user.service";
import moment from "moment";
export default {
  props: {
    loadingProp: {
      type: Boolean,
      default: false,
    },
    usersDataProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },
    totalRowProp: {
      type: Number,
    },
  },
  components: {
    // ShowDetail,
  },
  data() {
    return {
      show: true,
      userDataList: [],
      search: "",
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,
    };
  },
  watch: {
    loadingProp: {
      handler: function (newValue) {
        this.loading = newValue;
      },
      deep: true,
    },
    usersDataProp: {
      handler: function (newValue) {
        this.userDataList = newValue;
      },
      deep: true,
    },
    totalRowProp: {
      handler: function (newValue) {
        this.total_items = newValue;
        console.log(this.total_items);
      },
      deep: true,
    },
    perPageCount: function (newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal);
      this.$emit("tableAction", {
        index: this.page_size,
        data: null,
        kind: "perPageChange",
      });
    },
  },
  methods: {
    handleRowClick(row, column, event) {
      console.log(row, column, event);
    },
    handleShow(index, data) {
      this.$emit("tableAction", { index: index, data: data, kind: "edit" });
    },
    changePage(page) {
      this.$emit("tableAction", {
        index: page,
        data: null,
        kind: "changePage",
      });
    },
    isValidDate(dateString) {
      const dateRegex = /^(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
      if (dateRegex.test(dateString)) {
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          return true;
        } else {
          return false;
        }
      } else return false;
    },
    formattedDate(date) {
      return moment(date).format("YYYY/MM/DD HH:mm:ss");
    },
    maxDate(arr) {
      let maxDate = new Date(
        Math.max(
          ...arr.map((element) => {
            return new Date(element.created_at);
          })
        )
      );
      return maxDate;
    },
  },
};
</script>
